const AboutMe = `Hi, I'm Henry. \n
I am a software engineer living in the Bay Area and attended 4 years at the University of the Pacific. \n

My professional carrer has been incredible to say the least. The beginning of my carrer I started out as in IT, worked as a game programmer in Japan, and now a software developer.
I'm a continuous learner in my professional and personal life. Keeping up with new tech stacks through courses offered on Udemy and Pluralsight. In my personal life I train myself to stay healthy, learning new cooking recipes on youtube, and try to be the best version of myself!
I am always open to new opportunities!`

export default AboutMe;
